import React, { Component } from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router-dom';
import { withFirebase } from '../../Firebase';
import { toast, ToastContainer, Zoom } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { GaContext } from '../../googleAnalyticsContext/GaContext';
import { setUserEmailToLocalStorage } from '../../Firebase/localStorageForUserInfo';
import { apiEndPoints } from '../../common/globalConstants';
import {
  ACCESS_TOKEN_KEY,
  ANALYTICS_ID_KEY,
  ROLES_KEY,
  TOAST_ERROR_INVALID_USERNAME_OR_PASSWORD,
  USER_META_KEY,
} from './constants';
import {
  REACT_GA_USER_CATEGORY,
  REACT_GA_USER_LOGIN_MESSAGE_TEMPLATE,
} from '../../common/googleAnalyticsConstants';
import http from '../../common/http';

import { t } from 'i18next';
import {
  LOGIN_I18N_PREFIX as MY_I18N_PREFIX,
  LOGIN_I18N_KEYS as MY_I18N_KEYS
} from './constants/i18n/Logini18nConstants';


const emailPattern = /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/;

class LoginForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: '',
      password: '',
      formFieldType: 'password',
      rememberMe: false,
      isLoginActive: true,
      isLoggingIn: false,
      resetPasswordEmail: '',
      isResetPassword: false,
      error: {},
    };
  }

  static contextType = GaContext;
  componentDidMount() {
    const { ReactGA } = this.context;
    ReactGA.pageview('/login');
  }

  getI18nText(textKey,params={}) {
      return t(MY_I18N_PREFIX + "." + textKey,params);
  }

  login(user) {
    const { cookies } = this.props;
    const url = `${apiEndPoints.authentication.LOGIN}`;
    const bodyRequest = { userEmail: user.email, password: user.password };
    const doRequest = http.post(url, bodyRequest);
    doRequest.then(
      response => {
        const googleAnalyticsUserID = response.data[ANALYTICS_ID_KEY];
        this.setUserEmailAndUserRolesToLocalStorage(user.email, response);
        this.setUserMetaAndAccessTokenToCookies(cookies, response);
        this.setGoogleAnalyticsIdToGoogleAnalyticsContext(googleAnalyticsUserID);
        this.triggerGoogleAnalyticsEventForLogin(googleAnalyticsUserID);
        this.props.history.push(this.getDashboardRedirectUrl());
      },
      error => {
        this.setState({
          isLoggingIn: false,
        });
        toast.error(TOAST_ERROR_INVALID_USERNAME_OR_PASSWORD);
      },
    );
  }

  setGoogleAnalyticsIdToGoogleAnalyticsContext(googleAnalyticsUserID) {
    this.context.ReactGA.set({ userId: googleAnalyticsUserID });
  }

  triggerGoogleAnalyticsEventForLogin(googleAnalyticsID) {
    this.context.ReactGA.event({
      category: REACT_GA_USER_CATEGORY,
      action: REACT_GA_USER_LOGIN_MESSAGE_TEMPLATE + googleAnalyticsID,
    });
  }

  setUserMetaAndAccessTokenToCookies(cookies, response) {
    cookies.set(USER_META_KEY, response.data[ANALYTICS_ID_KEY], { path: '/' });
    cookies.set(ACCESS_TOKEN_KEY, response.data[ACCESS_TOKEN_KEY], { path: '/' });
  }

  setUserEmailAndUserRolesToLocalStorage(email, response) {
    setUserEmailToLocalStorage(email);
    localStorage.setItem(ROLES_KEY, response.data[ROLES_KEY]);
  }

  loginSubmit = event => {
    this.setState({
      isLoggingIn: true,
    });
    event.preventDefault();
    Object.keys(this.state).forEach(field => {
      if (['username', 'password'].indexOf(field) !== -1 && !this.state[field]) {
        let { error } = this.state;
        error[field] = true;
        this.setState({
          error,
          isLoggingIn: false,
        });
      } else {
        this.setState({ error: {}, isLoggingIn: false });
      }
    });
    const { error } = this.state;
    if (!Object.keys(error).length) {
      this.setState({
        isLoggingIn: true,
      });
      const { username, password } = this.state;
      const formData = {
        email: username,
        password: password,
      };
      this.login(formData);
    }
  };

  getDashboardRedirectUrl = () => {
    const pageToRedictTo = '/dashboard';
    if (window.location.search.length > 0) {
      return pageToRedictTo + window.location.search;
    } else {
      return pageToRedictTo;
    }
  };

  setFormData = event => {
    const key = event.target.name;
    const value = event.target.value;
    this.setState({
      [key]: value,
    });
  };
  setRememberMe = e => {
    this.setState({
      rememberMe: e.target.checked,
    });
  };
  setFormValues = e => {
    this.setState({
      resetPasswordEmail: e.target.value,
    });
  };
  validateEmail = () => {
    const { resetPasswordEmail } = this.state;

    if (!emailPattern.test(resetPasswordEmail)) {
      this.setState({ error: { email: true } });
      return false;
    } else {
      this.setState({
        error: { email: false },
      });
      return true;
    }
  };
  setLoginActive = value => {
    this.setState({
      isLoginActive: value,
      resetPasswordEmail: '',
      error: {},
    });
  };

  resetPasswordSubmit = event => {
    event.preventDefault();
    const { resetPasswordEmail } = this.state;
    if (! this.validateEmail()) {
      return false;
    }
    this.setState(
      {
        isResetPassword: true,
      },
      () => {
        const url = `${apiEndPoints.authentication.SEND_PASSWORD_RESET_EMAIL}`;
        const params = new URLSearchParams();
        params.append('userEmail', resetPasswordEmail);
        const doRequest = http.post(url, params);
        doRequest.then(
          response => {
            toast.success(this.getI18nText(MY_I18N_KEYS.password_reset_email_sent,{userEmail:resetPasswordEmail}));
            this.setState({ isPasswordChanging: false, isResetPassword: false},() => {
                 this.setLoginActive(true);
            });
          },
          error => {
            toast.error(this.getI18nText(MY_I18N_KEYS.error_sending_password_reset_email));
            this.setState({ isPasswordChanging: false, isResetPassword: false});
          },
        );
      },
    );
  };

  goToSignUpPage = () => {
    this.props.history.push('/signup');
  };

  renderSignInForm() {
    const {
      username,
      password,
      rememberMe,
      formFieldType,
      error,
      isLoginActive,
      resetPasswordEmail,
      isLoggingIn,
      isResetPassword,
    } = this.state;
    return isLoginActive ? (
      <div className="col-6 login">
        <div className="details-container">
          <form noValidate onSubmit={e => this.loginSubmit(e)}>
            <div className="form-group">
              <label>
                <strong>Username</strong>
              </label>
              <input
                type="email"
                className="form-control"
                defaultValue={username}
                name="username"
                onChange={e => this.setFormData(e)}
              />
              {error && error.email && (
                <span className="instruction-msg error">Please enter a valid email.</span>
              )}
            </div>
            <div className="form-group">
              <label>
                <strong>Password</strong>
              </label>
              <input
                type={formFieldType}
                className="form-control"
                name="password"
                defaultValue={password}
                onChange={e => this.setFormData(e)}
              />

              <i
                className={`la ${formFieldType === 'password' ? 'la-eye' : 'la-eye-slash'}`}
                onClick={() =>
                  this.setState(prevState => {
                    return {
                      formFieldType: prevState.formFieldType === 'password' ? 'text' : 'password',
                    };
                  })
                }
              ></i>
              {error && error.password && (
                <span className="instruction-msg error">Please enter password.</span>
              )}
            </div>

            <div className="remember-me  d-flex flex-row justify-content-between align-items-center">
              <div>
                <input
                  className="styled-checkbox"
                  type="checkbox"
                  id="rememberMe"
                  readOnly
                  checked={rememberMe}
                  value={rememberMe}
                  name="rememberMe"
                  onChange={e => this.setRememberMe(e)}
                />
                <label htmlFor="rememberMe">Remember me</label>
              </div>
              <div
                className="details-container forgot"
                onClick={() => this.setLoginActive(!isLoginActive)}
              >
                Forgot Password
              </div>
            </div>
            <div>
              <button type="submit" className={`btn btn-primary ${isLoggingIn && 'disabled'}`}>
                {isLoggingIn && <i className="la la-spinner la-spin" />}Log in
              </button>
            </div>
            <div className="new-user" onClick={() => this.goToSignUpPage()}>
              <span>Sign up for 1-month trial</span>
            </div>
          </form>
        </div>
      </div>
    ) : (
      <div className="col-6 login reset-container">
        <form>
          <div className="form-group">
            <label>
              <strong>Email</strong>
            </label>
            {error && error.email && (
              <span className="reset-error">
                <strong>*Please enter a valid email</strong>
              </span>
            )}
            <input
              type="email"
              name="email"
              defaultValue={resetPasswordEmail}
              className={`form-control input ${error && error.email && 'input-error'}`}
              onChange={e => this.setFormValues(e)}
              onBlur={this.validateEmail}
              autoComplete="off"
            />
            <span className="reset">
              A password reset link will be sent to the email address submitted.
            </span>

            <button
              type="submit"
              className={`btn btn-reset ${isResetPassword && 'disabled'}`}
              onClick={e => this.resetPasswordSubmit(e)}
            >
              {isResetPassword && <i className="la la-spinner la-spin" />} RESET PASSWORD
            </button>
            <div className="log-in" onClick={() => this.setLoginActive(!isLoginActive)}>
              <i className="la la-arrow-left"></i>
              Log In
            </div>
          </div>
        </form>
      </div>
    );
  }

  renderToastNotification() {
    return (
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar
        newestOnTop
        closeOnClick
        transition={Zoom}
        rtl={false}
        pauseOnVisibilityChange
        draggable={false}
        pauseOnHover={false}
      />
    );
  }

  render() {
    return (
      <div className="login-container">
        <div className="col-6 login "> </div>
        {this.renderSignInForm()}
        {this.renderToastNotification()}
      </div>
    );
  }
}

const Login = compose(withRouter, withFirebase)(LoginForm);

export default Login;



// WEBPACK FOOTER //
// ./src/features/login/Login.js